import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { t } from 'translate/store';
import SystemItem from '../systemItem';

const defaultValue = [
  {
    label: t('Tên công ty'),
    key: 'companyName',
    value: false,
  },
  {
    label: t('Tên Đại hội'),
    key: 'meetingName',
    value: false,
  },
  {
    label: t('Đa ngôn ngữ'),
    key: 'multiLanguage',
    value: false,
  },
  {
    label: t('Ủy quyền online'),
    key: 'onlineAuthorization',
    value: false,
  },
  {
    label: 'Logo',
    key: 'logo',
    value: false,
  },
  {
    label: t('Tải xuống kết quả'),
    key: 'resultDownload',
    value: false,
  },
  {
    label: 'Chat box',
    key: 'chatBox',
    value: false,
  },
  {
    label: t('Login khách mời'),
    key: 'guestLogin',
    value: false,
  },
  {
    label: t('Quên mật khẩu'),
    key: 'forgotPassword',
    value: false,
  },
  {
    label: t('Đăng nhập dành cho tổ chức'),
    key: 'enterpriseLogin',
    value: false,
  },
];

export default function ShareHolderSystem() {
  const [list, setList] = useState(defaultValue);
  const info = useSelector((state) => state.admin.configSystem.info);
  const { t } = useTranslation();
  useEffect(() => {
    if (info) {
      let newList = [...list];
      let keys = Object.keys(info);
      for (let i = 0; i < newList.length; i++) {
        if (keys.includes(newList[i].key)) {
          newList[i].value = info[newList[i].key];
        }
      }
      setList(newList);
    }
  }, [info]);
  return (
    <>
      <h4 className="category">{t('Hệ thống Cổ đông')}</h4>
      <div className="system-list">
        {list.map((item, index) => {
          return (
            <SystemItem
              key={index}
              keyName={item.key}
              name={item.label}
              status={item.value}
            />
          );
        })}
      </div>
    </>
  );
}
